<form [formGroup]="form">
    <div class="row mt-2" *ngIf="mostrarDocumento" id="fila_documento">
        <div class="col-4">
            <ca-form-field>
                <ca-label>{{'COMUN.DATOS_PERSONA.DOCUMENTO' | translate}}</ca-label>
                <input caInput 
                    placeholder="{{'COMUN.DATOS_PERSONA.DOCUMENTO' | translate}}"
                    type="text" 
                    [formControlName]="prefijoPersona + 'documento'" />           
                <ca-error *ngIf="form.controls[prefijoPersona + 'documento'].errors?.required">{{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
            </ca-form-field>                   
        </div>
        <div class="col-4" *ngIf="modoEdicion === 'SI' || modoEdicion === 'VALORES'">
            <ca-form-field>
                <ca-label>{{'COMUN.DATOS_PERSONA.TIPO_DOCUMENTO' | translate}}</ca-label>
                <ca-select
                    keyValue="descTipoDocumento"
                    valueField="idTipoDocumento"
                    [options]="tiposDocumento"
                    [formControlName]="prefijoPersona + 'tipo-documento'" 
                ></ca-select>
                <ca-error *ngIf="form.controls[prefijoPersona + 'tipo-documento'].errors?.required">{{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
            </ca-form-field>
        </div>
    </div>
    <div class="row mt-3" *ngIf="mostrarNombre" id="fila_nombre">
        <ng-container *ngIf="idTipoDocumentoSeleccionado!==idTipoDocumentoCIF ; else razonSocialContainer">
            <div class="col-4" >
                <ca-form-field>
                    <ca-label>{{'COMUN.DATOS_PERSONA.NOMBRE' | translate}}</ca-label>
                    <input 
                        caInput 
                        placeholder="{{'COMUN.DATOS_PERSONA.NOMBRE' | translate}}"
                        type="text" 
                        [formControlName]="prefijoPersona + 'nombre'" />
                    <ca-error *ngIf="form.controls[prefijoPersona + 'nombre'].errors?.required">{{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
                </ca-form-field>
            </div>

            <div class="col-4">
                <ca-form-field>
                    <ca-label>{{'COMUN.DATOS_PERSONA.APELLIDO_1' | translate}}</ca-label>
                    <input 
                        caInput 
                        placeholder="{{'COMUN.DATOS_PERSONA.APELLIDO_1' | translate}}"
                        type="text" 
                        [formControlName]="prefijoPersona + 'apellido1'" />
                    <ca-error *ngIf="form.controls[prefijoPersona + 'apellido1'].errors?.required">{{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
                </ca-form-field>
            </div>

            <div class="col-4">
                <ca-form-field>
                    <ca-label>{{'COMUN.DATOS_PERSONA.APELLIDO_2' | translate}}</ca-label>
                    <input 
                        caInput 
                        placeholder="{{'COMUN.DATOS_PERSONA.APELLIDO_2' | translate}}"
                        type="text" 
                        [formControlName]="prefijoPersona + 'apellido2'"/>
                    <ca-error *ngIf="form.controls[prefijoPersona + 'apellido2'].errors?.required">{{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
                </ca-form-field>
            </div>
        </ng-container>
        <ng-template #razonSocialContainer>
            <div class="col-4">
                <ca-form-field>
                    <ca-label>{{'COMUN.DATOS_PERSONA.RAZON_SOCIAL' | translate}}</ca-label>
                    <input 
                        caInput 
                        placeholder="{{'COMUN.DATOS_PERSONA.RAZON_SOCIAL' | translate}}"
                        type="text" 
                        [formControlName]="prefijoPersona + 'razon-social'"/>
                    <ca-error *ngIf="form.controls[prefijoPersona + 'razon-social'].errors?.required">{{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
                </ca-form-field>
            </div>
        </ng-template>
    </div>
    <div class="row mt-2" id="fila_fecha_sexo">
        <div class="col-4" *ngIf="mostrarFechaNacimiento && modoEdicion === 'NO'">
            <ca-form-field>
                <ca-label>{{'COMUN.DATOS_PERSONA.FECHA_NACIMIENTO' | translate}}</ca-label>
                <input 
                    caInput 
                    disabled
                    type="text" 
                    [value]="mostrarFecha(config?.persona?.fechaNacimiento)"/>
            </ca-form-field>
        </div>
        <div class="col-4" *ngIf="mostrarFechaNacimiento && modoEdicion === 'SI'">
            <ca-form-field>
                <ca-label>{{ 'COMUN.DATOS_PERSONA.FECHA_NACIMIENTO' | translate }}</ca-label>
                <ca-datepicker 
                    [formControlName]="prefijoPersona + 'fechaNacimiento'" 
                    [name]="prefijoPersona + 'fechaNacimiento'">
                </ca-datepicker>
            </ca-form-field>
            <ca-error *ngIf="form.controls[prefijoPersona + 'fechaNacimiento'].errors?.required">{{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
            <ca-error *ngIf="form.controls[prefijoPersona + 'fechaNacimiento'].errors?.pattern">{{'ERROR.ERROR_FORMATO_FECHA' | translate}}</ca-error>
        </div>
        <div class="col-4" *ngIf="mostrarSexo && modoEdicion === 'NO'">
            <ca-form-field>
                <ca-label>{{'COMUN.DATOS_PERSONA.SEXO' | translate}}</ca-label>
                <input 
                    caInput
                    disabled
                    type="text" 
                    [value]="config?.persona?.codigoSexo || ''"/>
            </ca-form-field>
        </div>                       
    </div>
</form>